import * as THREE from 'three';
import { getPortalCellCenter } from './portalPair';

export const createChainPreviewScene = (scene, surfaceY) => {
  const group = new THREE.Group();
  group.visible = false;
  scene.add(group);
  const outlines = Array.from({ length: 5 }, (_, position) => {
    const outline = new THREE.LineLoop(
      new THREE.BufferGeometry().setFromPoints([
        new THREE.Vector3(-1.22, 0, -1.22),
        new THREE.Vector3(1.22, 0, -1.22),
        new THREE.Vector3(1.22, 0, 1.22),
        new THREE.Vector3(-1.22, 0, 1.22),
      ]),
      new THREE.LineBasicMaterial({
        color: position ? 0xe29cff : 0x9affef,
        transparent: true,
        opacity: 0.9,
        toneMapped: false,
      })
    );
    group.add(outline);
    return outline;
  });
  const connections = new Float32Array(4 * 6);
  const geometry = new THREE.BufferGeometry().setAttribute(
    'position',
    new THREE.BufferAttribute(connections, 3)
  );
  const links = new THREE.LineSegments(
    geometry,
    new THREE.LineBasicMaterial({
      color: 0xd68cff,
      transparent: true,
      opacity: 0.65,
      toneMapped: false,
    })
  );
  group.add(links);
  let lastIndices = '';
  return {
    update(indices, elapsed, reduceMotion) {
      group.visible = indices.length > 0;
      if (!group.visible) return;
      const signature = indices.join(',');
      if (lastIndices !== signature) {
        lastIndices = signature;
        const origin = getPortalCellCenter(indices[0]);
        outlines.forEach((outline, position) => {
          outline.visible = position < indices.length;
          if (!outline.visible) return;
          const center = getPortalCellCenter(indices[position]);
          outline.position.set(center.x, surfaceY + 0.12, center.z);
          if (position) {
            const offset = (position - 1) * 6;
            connections.set(
              [
                origin.x,
                surfaceY + 0.11,
                origin.z,
                center.x,
                surfaceY + 0.11,
                center.z,
              ],
              offset
            );
          }
        });
        geometry.setDrawRange(0, Math.max(0, indices.length - 1) * 2);
        geometry.attributes.position.needsUpdate = true;
        geometry.computeBoundingSphere();
      }
      outlines.forEach((outline, position) => {
        outline.material.opacity = reduceMotion
          ? 0.9
          : 0.7 + Math.sin(elapsed * 3 - position * 0.65) * 0.25;
      });
    },
  };
};
